import { useEffect } from "react";
import { useGstMode } from "./useGstMode";

export const useGstShortcut = () => {
    const { gstEnabled, setGstMode } = useGstMode();

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            const isShortcut = (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'g';

            const isTyping =
                e.target instanceof HTMLInputElement ||
                e.target instanceof HTMLTextAreaElement ||
                (e.target as HTMLElement)?.isContentEditable;

            if (isShortcut && !isTyping) {
                e.preventDefault();
                setGstMode(gstEnabled ? 'NON-GST' : 'GST');
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown)
        }
    }, [gstEnabled, setGstMode])
}